import HeaderComponent from "@components/VerticalLayout/HeaderComponent";
import PageTitle from "@components/Common/PageTitle";
import React from "react";
import { useTranslation } from "react-i18next";
import { CardBody, Container } from "reactstrap";
import BreadcrumbOptions from "./BreadcrumbOptions";

function AdyenReportsOverview() {
    const { t } = useTranslation();

    const holderAccountId = localStorage.getItem("holderAccountId");
    return (
        <React.Fragment>
            <PageTitle title="Report SoftaveraPay" />
            <div className="">
                <BreadcrumbOptions
                    currentLink={[
                        {
                            item: t("SOFTAVERAPAY"),
                            link: `${process.env.REACT_APP_PORTAIL_API}`,
                        },
                        {
                            item: t(`${"Rapports"}`),
                            link: `${"Transactions"}`,
                        },
                        {
                          item: t(`${"Rapports"}`) ,
                          link: `${"Rapports"}`,
                        },
                    ]}
                />
                <Container fluid>
                    <HeaderComponent
                        title={t(
                            "The Reports section displays a list of downloadable reports for a specific balance account over a defined period."
                        )}
                    />

                    <CardBody
                        style={{
                            padding: "1px",
                        }}
                    >
                        <div
                            style={{
                                width: "100%",
                                marginTop: "10px",
                                height: "618px",
                            }}
                        >
                            <div style={{ width: "100%", height: "100%" }}>
                                <iframe
                                    src={`${process.env.REACT_APP_SOFTAVERAPAY}?accountHolder=${holderAccountId}&role=reports`}
                                    // src={`http://192.168.2.63:8082?accountHolder=${holderAccountId}&role=reports`}
                                    width="100%"
                                    height="100%"
                                    title="Embedded URL"
                                />
                            </div>
                        </div>
                    </CardBody>
                </Container>
            </div>
        </React.Fragment>
    );
}

export default AdyenReportsOverview;
